/**
 * @generated SignedSource<<ed40751c80e311530a50cc731432e540>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItem_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_viewer">;
  readonly " $fragmentType": "NavExpandingAreaItem_viewer";
};
export type NavExpandingAreaItem_viewer$key = {
  readonly " $data"?: NavExpandingAreaItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItem_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "35621491f69f31013d07fa6ba166c109";

export default node;
